import React from "react";

export default function Select({
  id,
  name,
  value,
  onChange,
  placeholder,
  options = [],
  optionValueKey,
  optionLabelKey,
  ...others
}) {
  const hasOptions = options.length > 0;
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      required
      {...others}
    >
      <option value={""} disabled hidden>
        {placeholder ? placeholder : "Select the option"}
      </option>
      {hasOptions &&
        options.map((optionItem, index) => (
          <option
            key={`${optionItem[optionValueKey]}_${index}`}
            value={optionItem[optionValueKey]}
          >
            {optionItem[optionLabelKey]}
          </option>
        ))}
    </select>
  );
}
